import React from 'react';
import { browserHistory } from 'react-router';

import { Button, Space, Tag } from 'antd';
import { InboxOutlined, CopyOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, colors } from '@yuhuinc/ui-library';

import { getTranslatedString } from 'helpers/i18n';

export default function TemplatesList({
  templates,
  loading,
  archiveApplicationTemplate,
  copyApplicationTemplate,
}) {
  const templatesSortedByStatus = [...templates].sort((a, b) => {
    const statusA = a.status.toUpperCase();
    const statusB = b.status.toUpperCase();
    if (statusA < statusB) {
      return 1;
    }
    if (statusA > statusB) {
      return -1;
    }
    // status must be equal
    return 0;
  });

  const toNewTemplate = () => {
    browserHistory.push('/companies/application_templates/new');
  };

  // Published templates are not editable
  const onClickTemplate = (template) => {
    if (template.status !== 'published') {
      browserHistory.push(`/companies/application_templates/${template.id}/edit`);
    }
  };

  const handlePreview = (template) => {
    browserHistory.push(`/companies/application_templates/${template.id}/wizard/preview`);
  };

  const columns = [
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.name'),
      dataIndex: 'name',
      searchable: true,
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => (
        <Button
          type="text"
          onClick={() => {
            onClickTemplate(record);
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.applications'),
      dataIndex: 'applications',
    },
    {
      title: getTranslatedString('common.status'),
      dataIndex: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
      render: (status) => (
        <Tag color={colors.TAG_STATUS_COLORS[status]}>
          {getTranslatedString(`landlordPortal.applicationTemplate.${status}`)}
        </Tag>
      ),
    },
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.languages'),
      dataIndex: 'selected_languages',
      render: (text) =>
        text.map((language) => getTranslatedString(`languages.${language}`)).join(', '),
    },
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.actions'),
      key: 'action',
      render: (template) => (
        <Space>
          <Button
            type="link"
            icon={<CopyOutlined />}
            onClick={() => copyApplicationTemplate(template)}
          />
          <Button
            type="link"
            icon={<InboxOutlined />}
            onClick={() => archiveApplicationTemplate(template)}
          />
          <Button type="link" icon={<EyeOutlined />} onClick={() => handlePreview(template)} />
        </Space>
      ),
    },
  ];

  return (
    <Table
      actionButtonLabel={getTranslatedString('landlordPortal.applicationTemplate.Add')}
      actionButtonOnClick={toNewTemplate}
      showActionButton
      dataSource={templatesSortedByStatus}
      columns={columns}
      loading={loading}
      pagination={{
        total: templates.length,
        hideOnSinglePage: true,
        size: 'small',
      }}
      rowKey="id"
      resetButtonOnClick={() => {}}
      title={getTranslatedString('landlordPortal.applicationTemplate.tabs.Templates')}
      scroll={{ x: false }}
    />
  );
}
